import React from 'react';
import { Modal, SelectionCard, Typography } from '@orijinworks/frontend-commons';
import {
  CASE_PLAN_SECTION_FALLBACK_TITLE,
  CASE_PLAN_WIDGET_MOVE_TO_SECTION_DESCRIPTION,
  CASE_PLAN_WIDGET_MOVE_TO_SECTION_HEADING,
} from '../../../../constants/reentry-planning.constants';
import {
  MoveWidgetToSectionListStyles,
  MoveWidgetToSectionModalStyles,
} from './MoveWidgetToSectionModal.styles';

const sectionDescription = (section) => section?.description?.trim() || ' ';

export function MoveWidgetToSectionModal({
  open = false,
  destinations = [],
  onSelect,
  onClose,
}) {
  if (!open) {
    return null;
  }

  return (
    <Modal
      open
      onClose={onClose}
      onContinue={onClose}
      actionBtnText=""
      cancelBtnText=""
      showFooter={false}
      labelledBy={CASE_PLAN_WIDGET_MOVE_TO_SECTION_HEADING}
      describedBy={CASE_PLAN_WIDGET_MOVE_TO_SECTION_HEADING}
      heading={CASE_PLAN_WIDGET_MOVE_TO_SECTION_HEADING}
      modalType={{ type: 'normal', status: 'info', size: 'medium' }}
      mainModalStyles={MoveWidgetToSectionModalStyles}
    >
      <Typography variant="body1">{CASE_PLAN_WIDGET_MOVE_TO_SECTION_DESCRIPTION}</Typography>
      <div style={MoveWidgetToSectionListStyles}>
        {destinations.map((section) => (
          <SelectionCard
            key={section.id}
            title={section.title?.trim() || CASE_PLAN_SECTION_FALLBACK_TITLE}
            description={sectionDescription(section)}
            onClick={() => onSelect(section.id)}
          />
        ))}
      </div>
    </Modal>
  );
}
